import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getApiUrl } from '../utils/api';
import './AdminList.css';

function AdminList() {
  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRooms();
    // Refresh rooms list every 3 seconds
    const interval = setInterval(fetchRooms, 3000);
    return () => clearInterval(interval);
  }, []);

  const fetchRooms = async () => {
    try {
      const apiUrl = await getApiUrl();
      const response = await fetch(`${apiUrl}/api/rooms`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log('Fetched rooms:', data);
      setRooms(Array.isArray(data) ? data : []);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching rooms:', error);
      setRooms([]);
      setLoading(false);
    }
  };

  const handleDeleteRoom = async (roomId) => {
    if (!window.confirm('Bạn có chắc chắn muốn xóa phòng này?')) {
      return;
    }

    try {
      const apiUrl = await getApiUrl();
      const response = await fetch(`${apiUrl}/api/room/${roomId}`, {
        method: 'DELETE'
      });
      const data = await response.json();
      if (data.success) {
        alert('Đã xóa phòng thành công');
        fetchRooms();
      } else {
        alert('Lỗi khi xóa phòng: ' + (data.error || 'Unknown error'));
      }
    } catch (error) {
      console.error('Error deleting room:', error);
      alert('Lỗi khi xóa phòng');
    }
  };

  const handleAccessRoom = (roomId) => {
    navigate(`/admin/${roomId}`);
  };

  const handleViewGame = (roomId) => {
    navigate(`/${roomId}`);
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    return new Date(timestamp).toLocaleString('vi-VN');
  };

  const getGameStateText = (state) => {
    const states = {
      'waiting': 'Đang chờ',
      'night': 'Đêm',
      'day': 'Ngày',
      'finished': 'Đã kết thúc'
    };
    return states[state] || state;
  };

  return (
    <div className="admin-list-container">
      <div className="container">
        <h1>🎮 Quản Lý Phòng Chơi</h1>
        
        <div className="admin-actions">
          <button 
            className="button" 
            onClick={() => navigate('/')}
            style={{ marginBottom: '20px' }}
          >
            ← Về Trang Chủ
          </button>
        </div>

        {loading ? (
          <div className="no-rooms">
            <p>Đang tải danh sách phòng...</p>
          </div>
        ) : rooms.length === 0 ? (
          <div className="no-rooms">
            <p>Chưa có phòng nào được tạo.</p>
            <button className="button" onClick={() => navigate('/')}>
              Tạo Phòng Mới
            </button>
          </div>
        ) : (
          <div className="rooms-list">
            <h2>Danh Sách Phòng ({rooms.length})</h2>
            <table className="rooms-table">
              <thead>
                <tr>
                  <th>Mã Phòng</th>
                  <th>Số Người Chơi</th>
                  <th>Cấu Hình</th>
                  <th>Trạng Thái</th>
                  <th>Thời Gian Tạo</th>
                  <th>Thao Tác</th>
                </tr>
              </thead>
              <tbody>
                {rooms.map((room) => (
                  <tr key={room.roomId}>
                    <td data-label="Mã Phòng">
                      <code className="room-id-small">{room.roomId.substring(0, 8)}...</code>
                    </td>
                    <td data-label="Số Người Chơi">
                      {room.numPlayers} / {room.config.numPlayers}
                    </td>
                    <td data-label="Cấu Hình">
                      <div className="room-config">
                        <span>Sói: {room.config.numWerewolves}</span>
                        {room.config.hasSeer && <span>Tiên Tri</span>}
                        {room.config.hasDoctor && <span>Bảo Vệ</span>}
                        {room.config.hasWitch && <span>Phù Thuỷ</span>}
                        {room.config.hasHunter && <span>Thợ săn</span>}
                        {room.config.hasLycan && <span>Bán sói</span>}
                      </div>
                    </td>
                    <td data-label="Trạng Thái">
                      <span className={`status-badge status-${room.gameState}`}>
                        {getGameStateText(room.gameState)}
                      </span>
                    </td>
                    <td data-label="Thời Gian Tạo">{formatDate(room.createdAt)}</td>
                    <td data-label="Thao Tác">
                      <div className="action-buttons">
                        <button
                          className="button button-small"
                          onClick={() => handleAccessRoom(room.roomId)}
                          title="Điều khiển phòng"
                        >
                          ⚙️ Admin
                        </button>
                        <button
                          className="button button-small"
                          onClick={() => handleViewGame(room.roomId)}
                          title="Xem phòng chơi"
                        >
                          👁️ Xem
                        </button>
                        <button
                          className="button button-small button-danger"
                          onClick={() => handleDeleteRoom(room.roomId)}
                          title="Xóa phòng"
                        >
                          🗑️ Xóa
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminList;

